export const FETCH_DIRECT_DEBIT_REQUEST = 'FETCH_DIRECT_DEBIT_REQUEST';
export const GET_DDI_TRANSACTION = 'DIRECT_DEBIT.GET_DDI_TRANSACTION';
export const CANCEL_MANDATE_SIGNING = 'DIRECT_DEBIT.CANCEL_MANDATE_SIGNING';
export const CONFIRM_MANDATE_SIGNING = 'DIRECT_DEBIT.CONFIRM_MANDATE_SIGNING';